'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require ('materialize-css');
require('jquery-lazy');
require('./contact');

$(function($) {
    $(".lazy").Lazy({
        threshold: 200,
        visibleOnly: false,
        delay: 200
    });
});

import swal from 'sweetalert';
//importarScript("js/jquery.waypoints.min.js");
var contLogin,campo,emailRegex;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$(window).scroll(function() {
    if($(window).width() < 600) {
        if ($(document).scrollTop() > 80) {
            $('#wpFloat').css('display','block');
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=75){
                $('#wpFloat').css('display','none');
            }
        }
    }
});

var card1 = 0,card2 = 0,card3 = 0,card4 = 0,card5 = 0;
$('.cardBox').click(function () {
    switch (this.id) {
        case '1':
            if(card1 == 0){
                card1 = 1;
                $('#card1').css('transform','rotateY(180deg)','important');
            }else{
                $('#card1').css('transform','rotateY(0deg)','important');
                card1 = 0;
            }
            break;
        case '2':
            if(card2 == 0){
                card2 = 1;
                $('#card2').css('transform','rotateY(180deg)','important');
            }else{
                $('#card2').css('transform','rotateY(0deg)','important');
                card2 = 0;
            }
            break;
        case '3':
            if(card3 == 0){
                card3 = 1;
                $('#card3').css('transform','rotateY(180deg)','important');
            }else{
                $('#card3').css('transform','rotateY(0deg)','important');
                card3 = 0;
            }
            break;
        case '4':
            if(card4 == 0){
                card4 = 1;
                $('#card4').css('transform','rotateY(180deg)','important');
            }else{
                $('#card4').css('transform','rotateY(0deg)','important');
                card4 = 0;
            }
            break;
        case '5':
            if(card5 == 0){
                card5 = 1;
                $('#card5').css('transform','rotateY(180deg)','important');
            }else{
                $('#card5').css('transform','rotateY(0deg)','important');
                card5 = 0;
            }
            break;
    }
});

$('.clickForm').click(function () {
    $('html, body').animate({
        scrollTop: $('#contact').offset().top - 0
    }, 2000);
});

var countDownDate = new Date("May 31, 2019 23:59:59").getTime();

// Update the count down every 1 second
var x = setInterval(function() {

    // Get todays date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="demo"
    //document.getElementById("demo").innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
    $('.sectionCountdown .days').html(days);
    $('.sectionCountdown .hours').html(hours);
    $('.sectionCountdown .minutes').html(minutes);
    $('.sectionCountdown .seconds').html(seconds);
    // If the count down is over, write some text
    if (distance < 0) {
        clearInterval(x);
        $('.sectionCountdown .days').html('0');
        $('.sectionCountdown .hours').html('0');
        $('.sectionCountdown .minutes').html('0');
        $('.sectionCountdown .seconds').html('0');
        //document.getElementById("demo").innerHTML = "EXPIRED";
    }
}, 0);
